<template>
  <div class="login">
    <div class="login_img">
      <img src="@/assets/img/login_img.png"
           alt="">
    </div>
    <div class="right"
         v-if="!$store.state.isLogin">
      <p>验证码登录</p>
      <div class="right_line"></div>
      <el-input placeholder="请输入手机号"
                v-model="phone"
                type="number"
                class="phone">
        <img slot="prefix"
             class="phone_img"
             src="@/assets/img/icon_phone.png"
             alt="">
      </el-input>
      <el-input placeholder="请输入验证码"
                v-model="code"
                type="number"
                class="phone">
        <img slot="prefix"
             class="phone_img"
             src="@/assets/img/icon_yzm.png"
             alt="">
        <span class="code_btn"
              slot="suffix"
              @click="sendCode">{{buttonName}}</span>
      </el-input>
      <!-- <div class="check">
        <el-checkbox v-model="checked"></el-checkbox>
        <div>
          <span class="tips">登录即注册代表同意并接受</span>
          <span class="xiyi"
                @click="serveTip">《用户服务协议》</span>
          <span class="xiyi"
                @click="yisiTip">《隐私协议》</span>
        </div>
      </div> -->
      <div class="login_btn"
           @click="loginBtn">登 录</div>
    </div>
    <div class="has_Login"
         v-else>
      <div class="per_left">
        <img src="@/assets/img/touxiang.png"
             alt="">
        <p>您好，ID:{{$store.state.loginCode}}</p>
        <p>手机号：{{$store.state.loginPhone}}</p>
      </div>
      <div class="login_btn"
           @click="logoutBtn">退 出 登 录</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      phone: '',
      code: '',
      checked: false,
      buttonName: "获取验证码",
      isDisabled: false,
      time: 60,
    }
  },
  created () {
  },
  methods: {
    sendCode () {
      if (this.phone.length !== 11) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        });
      } else {
        let param = {
          phone: this.phone,
          phoneSystem: "web",
          sendType: 1,
        }
        this.$post("/app/user/v1/sendVerifyCode", param)
          .then((res) => {
            console.log(res)
            if (res.code == 200) {
              this.setTimer();
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          })
          .catch((error) => { });
      }
    },
    setTimer () {//倒计时
      let me = this;
      me.isDisabled = true;
      let interval = setInterval(function () {
        me.buttonName = '（' + me.time + '秒）后重新发送';
        --me.time;
        if (me.time < 0) {
          me.buttonName = "获取验证码";
          me.time = 60;
          me.isDisabled = false;
          clearInterval(interval);
        }
      }, 1000);
    },
    loginBtn () {
      if (!this.phone) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        });
      } else if (!this.code) {
        this.$message({
          message: '请输入验证码',
          type: 'warning'
        });
      } else {
        this.register();
      }
      // else if (!this.checked) {
      //   this.$message({
      //     message: '请同意协议',
      //     type: 'warning'
      //   });
      // } 
    },
    register () {
      let param = {
        phone: this.phone,
        verifyCode: this.code,
        phoneSystem: "Android",
      }
      this.$post("/app/user/v1/register", param)
        .then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.$store.commit('login');
            this.$store.commit('loginCode', res.data.code);
            this.$store.commit('loginPhone', res.data.phone);
            sessionStorage.setItem("part_token", res.data.token);
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((error) => { });
    },
    logoutBtn () {
      this.$store.commit('logout');
      sessionStorage.removeItem("usercode");
      sessionStorage.removeItem("userphone");
      sessionStorage.removeItem("part_token");
    },
    serveTip () {

    },
    yisiTip () {

    }
  },
}
</script>

<style scoped>
.login {
  width: 100%;
  margin-top: 10px;
  padding: 15px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  display: flex;
}
.login_img {
  width: 667px;
  height: 460px;
}
.login_img img {
  width: 100%;
  height: 100%;
}
.right {
  width: 320px;
  margin-left: 60px;
  margin-top: 58px;
}
.right p {
  font-weight: 600;
  color: #333333;
  font-size: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f2f2f2;
}
.right_line {
  width: 80px;
  height: 2px;
  background: #e53631;
  margin-top: -2px;
  margin-bottom: 20px;
}
.phone {
  margin-top: 10px;
}
>>> .el-input__inner {
  height: 56px;
  background: #f9f9f9;
  border-radius: 2px;
}
.phone_img {
  width: 24px;
  height: 24px;
}
>>> .el-input__inner:focus {
  /* border-color: #ffffff; */
}
>>> .el-input__prefix,
>>> .el-input__suffix {
  display: inline-flex;
  align-items: center;
}
.code_btn {
  font-size: 16px;
  color: #e53631;
  line-height: 16px;
  font-size: 14px;
  margin-right: 10px;
}
.check {
  display: flex;
  margin-top: 20px;
}
.tips {
  color: #999999;
  margin-left: 5px;
}
.login_btn {
  height: 50px;
  background: #e53631;
  border-radius: 4px;
  margin-top: 40px;
  text-align: center;
  line-height: 50px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}

.has_Login {
  margin-left: 60px;
}
.per_left {
  /* width: 265px; */
  width: 320px;
  height: 226px;
  background: #f9f9f9;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.per_left img {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  margin-top: 30px;
}
.per_left p {
  font-size: 16px;
  color: #333333;
  line-height: 16px;
  margin-bottom: 15px;
}
</style>
